
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Agreements — the `agreements` list-and-pane widget. The page is a
// viewport-height column so the reading pane ends at the bottom of the
// window and scrolls inside itself (2026-09-07); the intro runs the full
// content width (2026-09-03).
export function Contracts(props: PageTemplateProps) {
    return <BasePage {...props} fullWidthIntro fillViewport />;
}
